import { Controller } from "@hotwired/stimulus"

/**
 * Interest Calculator Controller
 *
 * Displays interest calculation summary when dates are selected from the date picker.
 */
export default class extends Controller {
  static targets = ["calculationBox", "newTotalAmount", "totalInterestAccrued", "totalDebtBeforeInterest"]
  static values = {
    dateAmounts: Object,
  }

  connect() {
    this.setupDatePickerListener()
  }

  setupDatePickerListener() {
    // Find the date picker element in our form
    const datePickerElement = this.element.querySelector('[data-controller*="date-picker"]')

    if (datePickerElement) {
      // Get the hidden field
      const hiddenField = datePickerElement.querySelector('[data-date-picker-target="hidden"]')

      if (hiddenField) {
        // Watch for property changes using polling
        let originalValue = hiddenField.value
        setInterval(() => {
          if (hiddenField.value !== originalValue && hiddenField.value) {
            originalValue = hiddenField.value
            this.showCalculation(hiddenField.value)
          }
        }, 500)

        // Listen for input/change events as fallback
        hiddenField.addEventListener("input", (event) => {
          this.dateSelected(event)
        })

        hiddenField.addEventListener("change", (event) => {
          this.dateSelected(event)
        })
      }

      // Also listen on the displayed field for clicks
      const displayedField = datePickerElement.querySelector('[data-date-picker-target="displayed"]')
      if (displayedField) {
        displayedField.addEventListener("click", () => {
          // Check hidden field value after a delay to allow litepicker to update
          setTimeout(() => {
            const hiddenValue = hiddenField?.value
            if (hiddenValue) {
              this.showCalculation(hiddenValue)
            }
          }, 100)
        })
      }
    }
  }

  dateSelected(event) {
    const selectedDate = event.target.value

    this.showCalculation(selectedDate)
  }

  showCalculation(selectedDate) {
    const calculationValues = this.dateAmountsValue[selectedDate]

    this.newTotalAmountTarget.textContent = calculationValues.total_amount
    this.totalInterestAccruedTarget.textContent = calculationValues.total_interest
    this.totalDebtBeforeInterestTarget.textContent = calculationValues.total_debt_before_interest
  }
}
